import React from "react";

import { useTranslation, Trans } from "react-i18next";

import g1 from '../../img/AboutUs/g1.png';
import g2 from '../../img/AboutUs/g2.png';
import g3 from '../../img/AboutUs/g3.png';

function GlobalAwards () {

    const { t } = useTranslation();
      
    return(
        <div className="overflow-hidden relative">
            <div className="max-w-[1220px] mx-[20px] xl:mx-auto pt-[120px] xl:pt-[160px]">
                <p className="text-[32px] xl:text-[40px] italic font-[700] merriweather text-center"><Trans>{t('about.20')}</Trans></p>
                <div className="flex flex-wrap justify-center md:justify-between mt-[50px] xl:mt-[65px] gap-[30px]">
                    <img src={g1} alt="" />
                    <img src={g2} alt="" />
                    <img src={g3} alt="" />
                </div>
            </div>
        </div>
    );
}

export default GlobalAwards;